'use client'

// import { CommonListContext } from "@/app/analysis/_config"
import {CommonListContext} from "@/util/board_config"
import { AuthContext } from "@/context/authContext"
import api from "@/util/api"
import customAlert from "@/util/customAlert"
import { useContext, useRef } from "react"
import { useTranslations } from "next-intl"

// export default function ComentWrite({board_id, fetchData, post}: {board_id: number, fetchData?: Function, post:string}) {
export default function ComentWrite({
    board_id,
    fetchData,
    post,
    setSelectContent,   
    selectContent,
}: {
    board_id: number,
    fetchData?: Function,
    post: string,
    setSelectContent?: Function,
    selectContent?: any
}) {
    const inputRef = useRef<HTMLTextAreaElement>(null)
    const { user } = useContext(AuthContext)

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")
    

    function handleWrite() {
        if(!user.is_authenticated){
            customAlert(a('NeedLogin'), 'warning')
            return false
        }

        if(!inputRef.current || !inputRef.current.value){
            customAlert(a("InvalidComments"), 'warning')
            return;
        }
        const formData = new FormData()
        formData.set('type', 'insert')
        formData.set('board_id', `${board_id}`)
        formData.set('comment_content', `${inputRef.current.value}`)
        // console.log('as object', Object.fromEntries(formData.entries()));

        api(`${post}comment/edit/`, { method: "POST", body: formData })
            .then(res => res.json())
            .then(({status, message, data}) => {
// console.log(status, message, data)
                if (status == 'success'){


                    if (setSelectContent) {
                        setSelectContent((prev: any) => ({
                            ...prev,
                            comments: [data, ...(prev?.comments || [])]   
                        }))
                    }
// console.log(selectContent)
                    
                    if (fetchData) fetchData();

                    if(inputRef.current){
                        inputRef.current.value = ''
                    }                        
                }else{
                    customAlert(message, status)
                }
            })
            .catch((error: Response) =>{
// console.log(error)
            })
    }

    return (
        <div className="comment-write-container">
            <textarea name="content" ref={inputRef}></textarea>
            <div className="btn-container">
                <button onClick={handleWrite}>{t("등록")}</button>
            </div>
        </div>
    )
}